import consts from 'services/metaData/consts';
import moment from 'moment';

const MANUAL = 1;
const OPTIMIZED = 2;
const SORT_CPM = 3;

const formatDate = 'YYYY-MM-DD';
const datesOptions = [
    {
        id: 0,
        displayText: 'Today',
        startDay: moment()
            .format(formatDate),
        endDay: moment()
            .format(formatDate)
    },
    {
        id: 1,
        displayText: 'Yesterday',
        startDay: moment()
            .subtract(1, 'days')
            .format(formatDate),
        endDay: moment()
            .subtract(1, 'days')
            .format(formatDate)
    },
    {
        id: 2,
        displayText: 'Last 3 Days',
        endDay: moment()
            .subtract(0, 'days')
            .format(formatDate),
        startDay: moment()
            .subtract(2, 'days')
            .format(formatDate)
    },
    {
        id: 3,
        displayText: 'Last 7 Days',
        endDay: moment()
            .subtract(0, 'days')
            .format(formatDate),
        startDay: moment()
            .subtract(6, 'days')
            .format(formatDate)
    },
    {
        id: 4,
        displayText: 'Last 14 Days',
        endDay: moment()
            .subtract(0, 'days')
            .format(formatDate),
        startDay: moment()
            .subtract(13, 'days')
            .format(formatDate)
    },
    {
        id: 5,
        displayText: 'This Month',
        endDay: moment()
            .subtract(0, 'days')
            .format(formatDate),
        startDay: moment()
            .startOf('month')
            .format(formatDate)
    },
    {
        id: 6,
        displayText: 'Last Month',
        endDay: moment()
            .subtract(1, 'months')
            .endOf('month')
            .format(formatDate),
        startDay: moment()
            .subtract(1, 'months')
            .startOf('month')
            .format(formatDate)
    },
    {
        id: 7,
        displayText: 'Last 30 Days',
        endDay: moment()
            .subtract(0, 'days')
            .format(formatDate),
        startDay: moment()
            .subtract(29, 'days')
            .format(formatDate)
    }];
const helpMenuOptions = [
    {
        title: 'Sort by CPM',
        description: 'Networks are automatically sorted and delivered based on historical eCPMs or manually set rates'
    },
    {
        title: 'Manual',
        description: 'Networks are delivered in the order you place them'
    },
    {
        title: 'Optimized',
        description: 'Networks are automatically sorted and delivered based on the ironSource mediation algorithm'
    }
];
const EXPORT_ACTION = 'exportToCsv';
const IMPORT_ACTION = 'importFromCsv';
const exportCsvItems = [
    {
        id: EXPORT_ACTION,
        name: 'Export to CSV',
        iconData: { name: 'exportToCsvIcon', width: '18px', height: '16px' }
    },
    {
        id: IMPORT_ACTION,
        name: 'Import CSV',
        iconData: { name: 'importCsvIcon', width: '16px', height: '16px' }
    }
];

const exportToCsvHeaders = {
    waterfallTier: 'Waterfall Tier',
    rank: 'Rank',
    tierType: 'Tier Type',
    providerDisplayName: 'Ad Source',
    instanceName: 'Instance',
    rate: 'Rate',
    eCPM: 'eCPM ($)',
    impressions: 'Impressions',
    availabilityCheck: 'Ad Source Checks',
    availabilityRate: 'Availability Rate (%)',
    revenue: 'Revenue ($)',
    sov: 'SOV (%)'
};

export default Object.freeze({
    MANUAL,
    OPTIMIZED,
    SORT_CPM,
    TIER_TYPE_ORDER: [MANUAL, SORT_CPM, OPTIMIZED],
    TIER_TYPE_TO_NAME: {
        [MANUAL]: 'Manual',
        [OPTIMIZED]: 'Optimized',
        [SORT_CPM]: 'Sort by CPM'
    },
    TIER_POS_TO_COLOR: {
        1: consts.COLORS.PURPLE,
        2: consts.COLORS.TEAL,
        3: consts.COLORS.NEUTRAL_500
    },
    helpMenuOptions,
    datesOptions,
    exportCsvItems,
    adUnitToDeliveryType: {
        RV: 9,
        IS: 33,
        BN: 40
    },
    banner: 'BN',
    rateAnimation: 'rateAnimation',
    dragAndDropAnimation: 'dragAndDropAnimation',
    exportToCsvHeaders
});
